// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class ForgeProjectContextOverride {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(data) {
        this.projectId = data.projectId;
        this.theme = data.theme;
        this.themePreset = data.themePreset;
    }
    toRemote() {
        return {
            projectId: this.projectId,
            theme: this.theme,
            themePreset: this.themePreset,
        };
    }
}
